import { withPrefix } from 'gatsby'

export const SEARCH_INDEX_VERSION = 1

const EMPTY_DOCUMENT_INDEX = Object.freeze({
  documents: [],
  exactTickers: {},
  prefixes: {},
})

export const createEmptyLocalSearchIndex = () => ({
  availablePagePaths: null,
  contentMetadataByPath: new Map(),
  modelDetailPaths: new Set(),
  portfolioIndex: EMPTY_DOCUMENT_INDEX,
  productIndex: EMPTY_DOCUMENT_INDEX,
})

export const hydrateLocalSearchIndex = (payload) => {
  if (
    !payload ||
    typeof payload !== 'object' ||
    payload.version !== SEARCH_INDEX_VERSION
  ) {
    throw new Error('The local search index is missing or incompatible.')
  }

  const availablePagePaths = Array.isArray(payload.availablePagePaths)
    ? new Set(payload.availablePagePaths)
    : null

  return {
    availablePagePaths:
      availablePagePaths?.size > 0 ? availablePagePaths : null,
    contentMetadataByPath: new Map(
      Array.isArray(payload.contentMetadataByPath)
        ? payload.contentMetadataByPath
        : []
    ),
    modelDetailPaths: new Set(
      Array.isArray(payload.modelDetailPaths) ? payload.modelDetailPaths : []
    ),
    portfolioIndex: payload.portfolioIndex || EMPTY_DOCUMENT_INDEX,
    productIndex: payload.productIndex || EMPTY_DOCUMENT_INDEX,
  }
}

let localSearchIndexPromise = null

export const loadLocalSearchIndex = () => {
  if (localSearchIndexPromise) return localSearchIndexPromise

  if (typeof fetch !== 'function') {
    return Promise.resolve(createEmptyLocalSearchIndex())
  }

  localSearchIndexPromise = fetch(withPrefix('/search-index.json'), {
    credentials: 'same-origin',
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Local search index request failed: ${response.status}`)
      }
      return response.json()
    })
    .then(hydrateLocalSearchIndex)
    .catch((error) => {
      localSearchIndexPromise = null
      throw error
    })

  return localSearchIndexPromise
}

export const preloadLocalSearchIndex = () => {
  loadLocalSearchIndex().catch(() => {})
}
